{
  "version": 1,
  "asset_id": "91cc40dd-c7ef-453f-a62e-6da97d57a7fc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/91cc40dd-c7ef-453f-a62e-6da97d57a7fc/bypass-revision-oversized-pouch-en-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/91cc40dd-c7ef-453f-a62e-6da97d57a7fc/bypass-revision-oversized-pouch-en-320.webp",
  "original_filename": "bypass-revision-oversized-pouch-en-320.webp",
  "size": 13494,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:25Z"
}
